export enum SearchBy {
  AdNumber = 0,
  PositionOffered = 1,
  Location = 2,
  PostedDate = 3,
  Phone = 4,
  Fax = 5,
  Status = 6,
  From = 7,
  State = 8,
  Keyword = 9
}
export enum StatusFilter {
  NotSeleted = -1,
  PendingAuthorization = 1,
  Active = 2,
  NotActive = 3,
  Rejected = 4,
  Expired = 5
}
export interface IAdminSearchModel {
  statusFilter: StatusFilter;
  categoryFilter: number;
  stateFilter: number;
  searchBy: SearchBy;
  searchText: string;
  pageIndex: number;
  pageSize: number;
  dateStart: Date;
  dateEnd: Date;
}
